<template functional>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 658.57 658.57" style="fill:none;stroke:#000;stroke-width:24.81px"><rect class="cls-1" x="12.29" y="12.29" width="634" height="634" rx="75.42"/><polygon class="cls-1" points="530.96 124.44 380.71 124.44 380.71 148.66 380.71 534.13 530.96 534.13 530.96 148.66 530.96 124.44"/><rect class="cls-2" x="127.62" y="255.89" width="317" height="150.24"/></svg>
</template>

<script>
export default {}
</script>
